"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Palette is taken from mnemonics design manual
 * All palettes are created using
 * https://material.io/design/color/the-color-system.html#tools-for-picking-colors
 */
const Red = {
    50: "#FDEDEE",
    100: "#F9D1D3",
    200: "#E6A29E",
    300: "#DA8079",
    400: "#E26758",
    500: "#E65D42",
    600: "#D75440",
    700: "#C54B3A",
    800: "#B84634",
    900: "#A73E2B",
    A100: "#F9D1D3",
    A200: "#E6A29E",
    A400: "#E65D42",
    A700: "#C54B3A",
};
exports.default = Red;
